import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { BaseMediaApiModel } from '@rocksoft/inroom-sdk';

@Component({
  selector: 'era-radio-channel',
  templateUrl: './radio-channel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./radio-channel.component.scss'],
})
export class RadioChannelComponent {
  readonly radioChannel = input.required<BaseMediaApiModel>();
}
